<template lang="pug">

  .d-flex.align-center.justify-left

    //- v-icon(:size="25").mr-2 mdi-{{info.icon}}

    i(aria-hidden="true" :class="{ [info.icon]: true }").mdi.statisticIcon.mr-2

    span.statisticValue(v-if="!!info.loading === false")
      | {{ info.value || '0' }}
    v-progress-circular(v-else color="primary" indeterminate :size="16" :width="1")

    span.statisticDescription.pl-2
      | {{ info.description || 'Desconhecido' }}

</template>

<script>

  export default {
    name: 'InfoCard',

    /* components: {
    }, */

    props: {
      info: {
        type: Object,
        default: () => {},
      },
    },

    methods: {
      goToPlans () {
        return this.$router.push('/admin/assinatura')
      },
    },
  }

</script>

<style lang="scss" scoped>

  .statisticIcon {
    vertical-align: middle;

    color: rgba(0, 0, 0, 0.54);
    font-size: 25px;
    line-height: 25px;
  }

  .statisticValue {
    font-size: 19px;
    font-weight: 600;
  }

  .statisticDescription {
    color: rgba(0, 0, 0, 0.9);
    font-size: 15px;
  }

</style>
